// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__3--Td","title":"ClientInsurance_title__YZ2zx","itemText":"ClientInsurance_itemText__F-G3U"};